import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "aboutUs",
  initialState: {
    aboutUsData: [],
    added : false
  },
  reducers: {
    // GET Request
    addNewAboutUs: (aboutUs, action) => {
      //aboutUs.aboutUsData.push(action.payload);
      console.log("Added");
      console.log(action.payload);
      aboutUs.added = true;
    },
    getAboutUs: (aboutUs, action) => {
      aboutUs.aboutUsData = action.payload;
      aboutUs.added = false;
    },
    brokeragesReceived: (brokerages, action) => {
      brokerages.list = action.payload;
    },
  },
});

export const {
  addNewAboutUs,
  getAboutUs,
  editAboutUs,
  removeAboutUs,
  brokeragesReceived,
} = slice.actions;

export default slice.reducer;

// action creator
export const loadBrokerages = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages",
    method: "get",
    data: data,
    onSuccess: brokeragesReceived.type,
  });

export const loadAboutUs = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/aboutus",
    method: "post",
    data: {brokeragecode: data},
    onSuccess: getAboutUs.type,
  });

export const addAboutUs = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokerages/aboutus/add",
    method: "post",
    data: data,
    onSuccess: addNewAboutUs.type,
  });

export const updateAboutUs = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokerages/aboutus/update",
    method: "post",
    data: data,
    onSuccess: getAboutUs.type,
  });

export const deleteAboutUs = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokerages/aboutus/delete",
    method: "post",
    data: data,
    onSuccess: getAboutUs.type,
  });

// Selector

export const getBrokeragesList = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.list
);

export const aboutUsFormDataSelecter = createSelector(
  (state) => state.entities.aboutUs,
  (aboutUs) => aboutUs?.aboutUsData
);

export const aboutUsAddedSelector = createSelector(
  (state) => state.entities.aboutUs,
  (aboutUs) => aboutUs?.added
);
